import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Breadcrumb, Button, Space, Flex } from 'antd';
import { theme } from 'antd';
import { showSuccess, showError } from '../../../components/errorHandler';
import { apiRequest } from '../../../service/apiRequest';
import { useDispatch, useSelector } from 'react-redux';
import { AddModule } from '../../../redux/slice/userSlice';

import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

import { fetchMasterData } from '../../../redux/slice/masterSlice';
const Dashboard = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state: any) => state.user.user);

  const [todayStatus, setTodayStatus] = useState<boolean | null>(null);
  const [dashboadStaticData, setdashboadStaticData] = useState<any>({});

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const breadcrumbItems = [
    { title: 'Dashboard' },
    { title: 'Dashboard' },
  ];

  const getSidebarData = async () => {
    try {
      const getModule = await apiRequest({
        method: 'get',
        url: 'modules',
      });
      dispatch(AddModule(getModule));
    } catch (error) {
      showError('Failed to fetch dashboard data');
    }
  };
  const handleLogin = async () => {
    showSuccess('Login successfully!');
    setTodayStatus(true); // simulate login
  };

  const handleLogout = async () => {
    showSuccess('Logout successfully!');
    setTodayStatus(false); // simulate logout
  };

  const getDashboardData = async () => {
    try {
      const DashboardData = await apiRequest({
        method: 'get',
        url: 'dashboard',
      });
      setdashboadStaticData(DashboardData);
    } catch (error) {
      showError('Failed to get DashboardData');
    }
  };


  useEffect(() => {
    console.log('Dashboard mounted. User:', user);
    if (user) {
      dispatch(fetchMasterData());
    }
  }, [user, dispatch]);
  useEffect(() => {
    getDashboardData();
    getSidebarData();
  }, []);

  const recentOrderColumns = [
    {
      title: 'Product Name',
      dataIndex: 'product_name',
      key: 'product_name',
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
    },
    {
      title: 'Order Number',
      dataIndex: 'order_number',
      key: 'order_number',
    },
    {
      title: 'Order Date',
      dataIndex: 'created_on',
      key: 'created_on',
    },
  ];

  return (
    <>
      <Space
        style={{
          display: 'flex',
          marginBottom: '16px',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Breadcrumb items={breadcrumbItems} />
        <Flex gap="small">
          {todayStatus ? (
            <Button type="primary" danger onClick={handleLogout}>
              Logout for Today
            </Button>
          ) : (
            <Button type="primary" onClick={handleLogin}>
              Login for Today
            </Button>
          )}
        </Flex>
      </Space>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={6}><Card title="Total Products">{dashboadStaticData.total_products}</Card></Col>

        <Col span={6}><Card title="Total Orders">{dashboadStaticData.total_orders}</Card></Col>
        <Col span={6}><Card title="Revenue">{dashboadStaticData.total_revenue}</Card></Col>
        <Col span={6}><Card title="Customers">{dashboadStaticData.total_customer}</Card></Col>
      </Row>

      <Row>
        <Col span={24}>
          <Card title="Recent Orders">
            <Table
              columns={recentOrderColumns}
              dataSource={dashboadStaticData.recent_order || []}
              rowKey="order_number"
              pagination={{ pageSize: 5 }}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Dashboard;
